import React from 'react'
import { NextIcon, PrevIcon } from '../../../icons/Icons'
import QuickReply from './QuickReply'
import * as ReactDOM from 'react-dom'
import GeoReply from './GeoReply'
import { uid } from 'react-uid/dist/es5/index'
import classes from './styles.module.scss'
import classNames from 'classnames'

class QuickReplyList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      leftScrollValue: 0,
      showReplies: true,
      showAnimation: false,
      currentIndex: 0,
      showScroll: false,
      repliesAnimation: null,
    }
    this.replyList = React.createRef()
  }

  componentDidMount() {
    const { message } = this.props
    if (message && message.quickReplies)
      this.setState({ showScroll: this.scrollCounter() })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isFullScreenWidget !== this.props.isFullScreenWidget) {
      this.setState(
        {
          leftScrollValue: 0,
          currentIndex: 0,
        },
        () => {
          if (this.replyList && this.replyList.current) {
            this.replyList.current.scrollLeft = 0
          }
        },
      )
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.repliesAnimation)
  }

  nextItem = () => {
    this.scrollItems(true)
  }
  prevItem = () => {
    this.scrollItems(false)
  }
  scrollItems = next => {
    const { currentIndex } = this.state
    const scrollValue = ReactDOM.findDOMNode(this[`reply${currentIndex}`])
      ? ReactDOM.findDOMNode(
        this[`reply${currentIndex}`],
      ).getBoundingClientRect().width
      : 100
    let countedScrollValue =
      this.state.leftScrollValue + (next ? scrollValue : -scrollValue)
    const countedCurrentIndex = currentIndex + (next ? 1 : -1)
    if (!next) {
      countedScrollValue -= 8
    }
    this.setState(
      {
        leftScrollValue: countedScrollValue,
        currentIndex: countedCurrentIndex,
      },
      () => {
        this.replyList.current.scrollLeft = countedScrollValue
      },
    )
  }
  scrollCounter = () => {
    if (
      this.props.message.quickReplies &&
      this.props.message.quickReplies.length
    ) {
      let sumWidth = 0
      this.props.message.quickReplies.forEach((reply, index) => {
        sumWidth += ReactDOM.findDOMNode(this[`reply${index}`])
          ? ReactDOM.findDOMNode(this[`reply${index}`]).getBoundingClientRect()
            .width
          : 100
      })
      sumWidth += (this.props.message.quickReplies.length - 1) * 8
      //8px is additional margin

      return (
        this.replyList.current && this.replyList.current.offsetWidth < sumWidth
      )
    }
  }

  postReply = message => {
    ReactDOM.findDOMNode(this._wrapper).style.pointerEvents = 'none'

    const repliesAnimation = setTimeout(() => {
      this.setState({
        showReplies: false,
      })
      this.props.postMessage(message)
    }, 700)

    this.setState({ showAnimation: true }, () => repliesAnimation)
  }

  checkPrevArrow = () => {
    return (
      this.props.message.quickReplies &&
      this.replyList &&
      this.replyList.current &&
      this.state.leftScrollValue > 0
    )
  }

  checkNextArrow = () => {
    return (
      this.props.message.quickReplies &&
      this.props.message.quickReplies.length > 1 &&
      (this.state.leftScrollValue === 0 ||
        (this.replyList.current &&
          this.replyList.current.scrollWidth -
            this.replyList.current.offsetWidth >
            this.state.leftScrollValue))
    )
  }

  render() {
    const { message, color, isMobile } = this.props
    const { showReplies, showAnimation } = this.state

    const visibility = !showReplies && { visibility: 'hidden' }
    let customStyles = showAnimation && { animation: '.7s fadeOut' }
    customStyles = { ...customStyles, ...visibility }

    const showScroll = false

    return (
      <div
        style={customStyles}
        className={classes.listContainer}
        ref={node => (this._wrapper = node)}>
        {!isMobile && this.checkPrevArrow() && showScroll && (
          <div onClick={this.prevItem} className={classes.prevIcon}>
            <PrevIcon />
          </div>
        )}
        {message.quickReplies && (
          <div
            ref={this.replyList}
            className={classes.list}
            style={{
              justifyContent: !showScroll ? 'center' : 'left',
              overflowX: isMobile ? 'scroll' : 'hidden',
            }}>
            {message.quickReplies.map((reply, index) => (
              <div
                key={uid(reply)}
                ref={node => (this[`reply${index}`] = node)}>
                {reply.type && reply.type === 'text' ? (
                  <QuickReply
                    postMessage={msg => this.postReply(msg)}
                    color={color}
                    reply={reply}
                  />
                ) : (
                  <GeoReply postMessage={msg => this.postReply(msg)} />
                )}
              </div>
            ))}
          </div>
        )}
        {!isMobile && this.checkNextArrow() && showScroll && (
          <div className={classNames(classes.nextIcon, 'qr-list-next-btn')} onClick={this.nextItem}>
            <NextIcon />
          </div>
        )}
      </div>
    )
  }
}

export default QuickReplyList
